import { PropsWithChildren, useMemo } from 'react'
import { ConfigProvider as AntdConfigProvider } from '@vivaldis/antd-ui'
import { BrickJobsTheme, VivaldisTheme } from '@vivaldis/ui'
import { APP_BRANDS, useAppBrand } from '@vivaldis/common'

export const ConfigProvider = ({ children }: PropsWithChildren<unknown>) => {
  const appBrand = useAppBrand()

  const theme = useMemo(
    () => (appBrand === APP_BRANDS.BrickJobs ? BrickJobsTheme : VivaldisTheme),
    [appBrand]
  )

  return <AntdConfigProvider appTheme={theme}>{children}</AntdConfigProvider>
}
